import { defineMessages } from 'react-intl-next';

// @TODO: update other imports once translated
export const i18n = defineMessages({
	invalidValue: {
		id: 'automation-extensions.smart-button.form-data.invalid-text-value.message',
		defaultMessage: 'Please provide a valid value.',
		description: 'Error message for an invalid config value in an automation action',
	},
	invalidSmartValue: {
		id: 'automation-extensions.smart-button.form-data.invalid-smart-value.message',
		defaultMessage:
			'Please enter a properly formatted input smart value, wrapped in double curly brackets.',
		description:
			'Error message for an invalid smart value entered in the text field of automation actions requiring smart values',
	},
	pageStatusNotFound: {
		id: 'automation-extensions.smart-button.form-data.page-status-not-found.label',
		defaultMessage: 'Page status not found',
		description: 'Label for a page status that is no longer available',
	},
	unknownSpace: {
		id: 'automation-extensions.smart-button.form-data.unknown-space.label',
		defaultMessage: 'Unknown space',
		description: 'Label for a space when the space name is not available',
	},
	sameSpaceAsTrigger: {
		id: 'automation-extensions.smart-button.form-data.same-space-as-trigger.label',
		defaultMessage: 'Same space as trigger',
		description: 'Label for the option to use the same space as the trigger',
	},
});
